/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, {Fragment, useCallback, useEffect, useMemo, useState} from 'react'
import {KTSVG} from '../../../_metronic/helpers'
import Modal from 'react-bootstrap/Modal'
import {useTranslation} from 'react-i18next'
import axios from 'axios'
import {getAccess} from '../../../api/modules/master-data/master_2'
import Pagination from '../component/Pagination'
import Accordion from 'react-bootstrap/Accordion'
import Checkbox from './Checkbox'
import swal from 'sweetalert'
import {getAccesses} from '../../../api/modules/access/access'
import {RowFilter} from './RowFilter'
import {useAppDispatch, useAppSelector} from '../../../redux/hooks'
import {objToParams} from '../../../utils/objToParams'
import {fetchRoles, headers} from '../../../services/fetcher'
import {ButtonGroups} from './ButtonGroups'
import * as TableUI from '../../../components/Table/Table'
import {useRowTable} from '../../../hooks/useRowTable'
import {filterSelector, resetFilterRole, setIsFetchData} from '../../../redux/slices/filterSlices'
import {StyledCard} from '../../../components/StyledCard'
import {HakAkses} from '../../../components/mikro/getHakAkses'
import {authSelector} from 'src/redux/slices/authSlices'

type Props = {
  className: string
}

const TableAccess: React.FC<Props> = ({className}) => {
  const {t} = useTranslation()
  const {roleId} = useAppSelector(authSelector)
  const {filterRole: filter} = useAppSelector(filterSelector)
  const dispatch = useAppDispatch()
  const hakAkses = HakAkses()

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 4,
    onReloadTable: () => handleResetTable(),
  })

  const [show, setShow] = useState(false)

  const handleClose = () => setShow(false)
  const handleShow = () => setShow(true)

  const [roleAccess, setRoleAccess] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [numberURL, setNumberURL] = useState([])
  const [accesses, setAccesses] = useState<any>()
  const [isError, setIsError] = useState(false)

  const rowNumber = useMemo(() => {
    const per = filter.per_page || 5
    return page * per - per
  }, [page, filter?.per_page])

  const onFetchRoles = useCallback(() => {
    setLoading(true)
    setIsError(false)
    fetchRoles(filter)
      .then((res: any) => {
        setRoleAccess(res.data.data.data)
        setNumberURL(res.data.data.links)
        setPage(res.data.data.current_page)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filter])

  useEffect(() => {
    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccesses(roleId)
      setAccesses(res.data.data)
    }

    getAccessMenu()
  }, [])

  const paginateNumber = async (url: any) => {
    try {
      setLoading(true)
      setIsError(false)

      const endpoint = `${url}&${objToParams({...filter})}`
      const token = localStorage.getItem('token') as string
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setRoleAccess(data.data)
      setPage(data.current_page)
      setNumberURL(data.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  const [access, setAccess] = useState<any[]>([])
  const [accessId, setAccessId] = useState<any>('')
  const [list, setList] = useState<any[]>([])

  const handleEdit = async (id: any) => {
    setAccessId(id)
    handleShow()
    setLoading(true)
    const res = await getAccess(id)
    setLoading(false)
    setAccess(res.data.data)
    // console.log(res.data.data)
    setList(res.data.data)
  }

  const handleClick = (e: any) => {
    const {id, checked, name} = e.target

    if (name == 'create') {
      if (!checked) {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, create: false} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, create: false} : sub
          )

          return item
        })
        setList(newList)
      } else {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, create: true} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, create: true} : sub
          )

          return item
        })
        setList(newList)
      }
    }

    if (name == 'read') {
      if (!checked) {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, read: false} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, read: false} : sub
          )

          return item
        })
        setList(newList)
      } else {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, read: true} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, read: true} : sub
          )

          return item
        })
        setList(newList)
      }
    }

    if (name == 'update') {
      if (!checked) {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, update: false} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, update: false} : sub
          )

          return item
        })
        setList(newList)
      } else {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, update: true} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, update: true} : sub
          )

          return item
        })
        setList(newList)
      }
    }

    if (name == 'delete') {
      if (!checked) {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, delete: false} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, delete: false} : sub
          )

          return item
        })
        setList(newList)
      } else {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, delete: true} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, delete: true} : sub
          )

          return item
        })
        setList(newList)
      }
    }

    if (name == 'approve') {
      if (!checked) {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, approve: false} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, approve: false} : sub
          )

          return item
        })
        setList(newList)
      } else {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, approve: true} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, approve: true} : sub
          )

          return item
        })
        setList(newList)
      }
    }

    if (name == 'export') {
      if (!checked) {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, export: false} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, export: false} : sub
          )

          return item
        })
        setList(newList)
      } else {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, export: true} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, export: true} : sub
          )

          return item
        })
        setList(newList)
      }
    }

    if (name == 'print') {
      if (!checked) {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, print: false} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, print: false} : sub
          )

          return item
        })
        setList(newList)
      } else {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, print: true} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, print: true} : sub
          )

          return item
        })
        setList(newList)
      }
    }

    if (name == 'attachment_delete') {
      if (!checked) {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, attachment_delete: false} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, attachment_delete: false} : sub
          )

          return item
        })
        setList(newList)
      } else {
        const newList = list.map((item: any) => {
          item = item.id == id ? {...item, attachment_delete: true} : item
          item.sub_menu = item.sub_menu.map((sub: any) =>
            sub.id == id ? {...sub, attachment_delete: true} : sub
          )

          return item
        })
        setList(newList)
      }
    }
  }

  const [actived, setActived] = useState(false)

  const catalog = access.map((item: any, index: number) => {
    return (
      <Accordion key={index}>
        <Accordion.Item eventKey={item.id}>
          <Accordion.Header>{item.name}</Accordion.Header>
          <Accordion.Body id='body'>
            <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
              <tr className='fw-bold  d-flex jusify-content-center w-100 align-items-center'>
                <th className='td-order-3 text-center'>Menu</th>
                <th className='td-order-1 text-center'>{t('Membuat')}</th>
                <th className='td-order-1 text-center'>{t('Membaca')}</th>
                <th className='td-order-1 text-center'>{t('Memperbarui')}</th>
                <th className='td-order-1 text-center'>{t('Menghapus')}</th>
                <th className='td-order-1 text-center'>{t('setujui')}</th>
                <th className='td-order-1 text-center'>{t('Export')}</th>
                <th className='td-order-1 text-center'>{t('print')}</th>
                <th className='td-order-1 text-center'>
                  {t('ACCESS_MENU_MODAL.DELETE_ATTACHMENT_TH')}
                </th>
              </tr>
              <tr className='d-flex jusify-content-center w-100 align-items-center'>
                <Fragment key={item.id}>
                  <td className='td-order-3 text-center'>{item.name}</td>
                  <td className='td-order-1 text-center'>
                    <Checkbox
                      type='checkbox'
                      name='create'
                      id={item.id}
                      handleClick={handleClick}
                      isChecked={item.create}
                    />
                  </td>
                  <td className='td-order-1 text-center'>
                    <Checkbox
                      type='checkbox'
                      name='read'
                      id={item.id}
                      handleClick={handleClick}
                      isChecked={item.read}
                    />
                  </td>
                  <td className='td-order-1 text-center'>
                    <Checkbox
                      type='checkbox'
                      name='update'
                      id={item.id}
                      handleClick={handleClick}
                      isChecked={item.update}
                    />
                  </td>
                  <td className='td-order-1 text-center'>
                    <Checkbox
                      type='checkbox'
                      name='delete'
                      id={item.id}
                      handleClick={handleClick}
                      isChecked={item.delete}
                    />
                  </td>
                  <td className='td-order-1 text-center'>
                    <Checkbox
                      type='checkbox'
                      name='approve'
                      id={item.id}
                      handleClick={handleClick}
                      isChecked={item.approve}
                    />
                  </td>
                  <td className='td-order-1 text-center'>
                    <Checkbox
                      type='checkbox'
                      name='export'
                      id={item.id}
                      handleClick={handleClick}
                      isChecked={item.export}
                    />
                  </td>
                  <td className='td-order-1 text-center'>
                    <Checkbox
                      type='checkbox'
                      name='print'
                      id={item.id}
                      handleClick={handleClick}
                      isChecked={item.print}
                    />
                  </td>
                  <td className='td-order-1 text-center'>
                    <Checkbox
                      type='checkbox'
                      name='attachment_delete'
                      id={item.id}
                      handleClick={handleClick}
                      isChecked={item['attachment_delete']}
                    />
                  </td>
                </Fragment>
              </tr>

              {item.sub_menu.map((item: any, index: number) => {
                return (
                  <tr
                    key={item?.id ?? index}
                    className='d-flex jusify-content-center w-100 align-items-center'
                  >
                    <Fragment key={item.id}>
                      <td className='td-order-3 text-center'>{item.name}</td>
                      <td className='td-order-1 text-center'>
                        <Checkbox
                          type='checkbox'
                          name='create'
                          id={item.id}
                          handleClick={handleClick}
                          isChecked={item.create}
                        />
                      </td>
                      <td className='td-order-1 text-center'>
                        <Checkbox
                          type='checkbox'
                          name='read'
                          id={item.id}
                          handleClick={handleClick}
                          isChecked={item.read}
                        />
                      </td>
                      <td className='td-order-1 text-center'>
                        <Checkbox
                          type='checkbox'
                          name='update'
                          id={item.id}
                          handleClick={handleClick}
                          isChecked={item.update}
                        />
                      </td>
                      <td className='td-order-1 text-center'>
                        <Checkbox
                          type='checkbox'
                          name='delete'
                          id={item.id}
                          handleClick={handleClick}
                          isChecked={item.delete}
                        />
                      </td>
                      <td className='td-order-1 text-center'>
                        <Checkbox
                          type='checkbox'
                          name='approve'
                          id={item.id}
                          handleClick={handleClick}
                          isChecked={item.approve}
                        />
                      </td>
                      <td className='td-order-1 text-center'>
                        <Checkbox
                          type='checkbox'
                          name='export'
                          id={item.id}
                          handleClick={handleClick}
                          isChecked={item.export}
                        />
                      </td>
                      <td className='td-order-1 text-center'>
                        <Checkbox
                          type='checkbox'
                          name='print'
                          id={item.id}
                          handleClick={handleClick}
                          isChecked={item.print}
                        />
                      </td>
                      <td className='td-order-1 text-center'>
                        <Checkbox
                          type='checkbox'
                          name='attachment_delete'
                          id={item.id}
                          handleClick={handleClick}
                          isChecked={item['attachment_delete']}
                        />
                      </td>
                    </Fragment>
                  </tr>
                )
              })}
            </table>
          </Accordion.Body>
        </Accordion.Item>
      </Accordion>
    )
  })

  const handleSave = async () => {
    const result = list
      .reduce((prev, {sub_menu, ...rest}, index, arr) => {
        return [...prev, [rest, ...sub_menu]]
      }, [])
      .flat()
      .map((item: any) => {
        return {
          menu_id: item.id,
          approve: item.approve ? 1 : 0,
          create: item.create ? 1 : 0,
          delete: item.delete ? 1 : 0,
          read: item.read ? 1 : 0,
          update: item.update ? 1 : 0,
          export: item.export ? 1 : 0,
          print: item.print ? 1 : 0,
          attachment_delete: item['attachment_delete'] ? 1 : 0,
        }
      })

    axios
      .post(
        `${process.env.REACT_APP_PI_BACKEND_API_USERMANAGEMENT}/role-access/create`,
        {
          role_id: accessId,
          menus: result,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('token')}`,
            apikey: `1k1BGGqAkfpXvHrxPCsWIUUDySfgVFYw`,
            Accept: 'application/json',
            'Access-Control-Allow-Origin': '*',
          },
        }
      )
      .then((response) => {
        swal({
          title: `${t('Role Berhasil di Ubah')}`,
          icon: 'success',
        })
          .then(() => {
            setActived(!actived)
          })
          .catch((error) => {})
      })
  }

  const handleResetTable = () => {
    dispatch(resetFilterRole())
  }

  useEffect(() => {
    const getData = setTimeout(onFetchRoles, 1000)
    return () => clearTimeout(getData)
  }, [onFetchRoles])

  useEffect(() => {
    return () => {
      handleResetTable()
    }
  }, [])

  return (
    <StyledCard>
      <ButtonGroups />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <TableUI.THead>
            <tr>
              <th>{t('No')}</th>
              <th>{t('nama')}</th>
              {hakAkses?.update && <th>{t('akses')}</th>}
            </tr>
          </TableUI.THead>

          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : roleAccess.length === 0 ? (
              <RowEmptyData />
            ) : (
              roleAccess.map((roleAccess: any, _index: number) => (
                <tr key={_index}>
                  <td>
                    <span>{_index + 1 + rowNumber}</span>
                  </td>
                  <td>
                    <span>{roleAccess?.name.replace(/ for /i, ' ' + t('untuk') + ' ')}</span>
                  </td>
                  {hakAkses?.update && (
                    <td>
                      <button
                        className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                        title={t('editaccessmenu')}
                        onClick={() => handleEdit(roleAccess.id)}
                      >
                        <KTSVG path='/media/icons/duotune/gear-fill.svg' className='svg-icon-3' />
                      </button>
                    </td>
                  )}
                </tr>
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={show}
        onHide={handleClose}
        backdrop='static'
        keyboard={false}
        size='xl'
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>{t('akses')} Menu</Modal.Title>
        </Modal.Header>
        <Modal.Body id='modal-access'>
          {loading ? (
            <h2 className='text-center my-10'>Loading ...</h2>
          ) : (
            <Accordion>
              {catalog}

              <div className='d-flex justify-content-end my-5 me-5'>
                <button onClick={handleSave} className='btn btn-primary'>
                  {t('ubah')}
                </button>
              </div>
            </Accordion>
          )}
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {TableAccess}
